import types from 'redux/types';

const changeTheme = (theme) => {
  return {
    type: types.CHANGE_THEME,
    theme,
  };
};

const getCountriesAvailable = () => {
  return {
    type: types.REQUEST_AVAILABLE_COUNTRIES,
  };
};

const getLoadConfig = () => {
  return {
    type: types.REQUEST_LOAD_CONFIG,
  };
};

const getCarrierList = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_CARRIER,
  };
};

const getLoadPriceTable = () => {
  return {
    type: types.REQUEST_GET_TABLE_PRICE,
  };
};

const getLoadRouteList = () => {
  return {
    type: types.REQUEST_ROUTE_LIST,
  };
};

const getVoluumSetting = (data) => {
  return {
    ...data,
    type: types.REQUEST_API_VOLUUM_SETTING,
  };
};

const updateVoluumSetting = (data) => {
  return {
    ...data,
    type: types.UPDATE_API_VOLUUM_SETTING,
  };
};

export default {
  changeTheme,
  getLoadRouteList,
  getLoadPriceTable,
  getCarrierList,
  getCountriesAvailable,
  getLoadConfig,
  getVoluumSetting,
  updateVoluumSetting,
};
